import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})

export class UseCurrentFilesCommandHandler implements IPlatformCommandHandler {
  constructor(private platformQueryService: PlatformQueryService) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const query = new PlatformQuery();
    query.name = 'RecentItemsQuery';
    query.api = 'FileStoreApi';
    query.isCamelCase = true;
    query.fieldValues = command.fieldValues;
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(res => {
      console.log(res);
      if (res.fieldValues) {
        command.fieldValues['FileLocationsFieldKey'] = res.fieldValues['FileLocationsFieldKey'];
        handler.executeCommand(command);
        handler.invalidateSubject.invalidate();
        return true;
      }
    });
    return false;
  }
}
